export default {
    getOrigin: (url) => {
        let a = document.createElement("a");
        a.href = url;

        let host = a.host;
        host = host.replace(/:80$/, "");
        host = host.replace(/:443$/, "");

        return a.protocol + "//" + host;
    }
}